import { __awaiter, __generator } from "tslib";
var genUUID = function (length) {
    if (length === void 0) { length = 16; }
    var s = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    var max = s.length;
    var res = "";
    var i = 0;
    for (; i < length; i++) {
        var ran = Math.floor(Math.random() * max);
        res += s[ran];
    }
    return res;
};
var uuid = genUUID(16);
export function getSDKReadyFunc(src, options) {
    if (options === void 0) { options = {}; }
    if (typeof options === "string") {
        // 忽略老版本参数
    }
    else if (typeof window !== "undefined") {
        // SSR兼容
        window._HG_WEB_SDK_INIT_OPTIONS = options;
    }
    return Object.assign(function sdkReady(callback) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        var SDK = window.HG_SDK;
                        if (SDK) {
                            callback === null || callback === void 0 ? void 0 : callback(SDK);
                            resolve(SDK);
                            return;
                        }
                        else {
                            window._HG_SDK_CALLBACK_QUEUE =
                                window._HG_SDK_CALLBACK_QUEUE || [];
                            window._HG_SDK_CALLBACK_QUEUE.push(function () { return __awaiter(_this, void 0, void 0, function () {
                                var _a;
                                return __generator(this, function (_b) {
                                    switch (_b.label) {
                                        case 0:
                                            _a = resolve;
                                            return [4 /*yield*/, sdkReady(callback)];
                                        case 1:
                                            _a.apply(void 0, [_b.sent()]);
                                            return [2 /*return*/];
                                    }
                                });
                            }); });
                        }
                        var scriptElem = window.document.getElementById(uuid);
                        if (!scriptElem) {
                            scriptElem = window.document.createElement("script");
                            scriptElem.defer = true;
                            scriptElem.src = src + "?ts=".concat(Date.now());
                            scriptElem.id = uuid;
                            window.document.head.appendChild(scriptElem);
                        }
                        scriptElem.addEventListener("error", reject);
                    })];
            });
        });
    }, {
        SDK_TYPE: "HG",
    });
}
